// Sentry MUST be the first import so it captures errors thrown during
// module evaluation. Fully dormant if REACT_APP_SENTRY_DSN is unset —
// see ./sentry-init.js.
import "./sentry-init";
import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import "@/styles/docs.css";
// Iter249 — initialise i18n BEFORE App renders so the first paint is in
// the user's chosen language (no English-flash before swap).
import "@/i18n";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
